/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const FieldColorSmallIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="FieldColorSmallIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              d="M12 8C13.0355 8 13.875 7.16053 13.875 6.125C13.875 5.78532 13.7815 5.4481 13.6073 5.15901L12 2L10.3929 5.15854C10.2186 5.44777 10.125 5.78514 10.125 6.125C10.125 7.16053 10.9645 8 12 8Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6 14C4.067 14 2.5 12.433 2.5 10.5C2.5 9.86736 2.67349 9.23988 2.99795 8.69976L5.13398 5.00004C5.51889 4.33337 6.48114 4.33337 6.86604 5.00004L9.00254 8.70057C9.32666 9.24046 9.5 9.86767 9.5 10.5C9.5 12.433 7.933 14 6 14ZM3.5 10.5C3.5 11.8807 4.61929 13 6 13C7.38071 13 8.5 11.8807 8.5 10.5C8.5 10.047 8.37487 9.59666 8.14343 9.21238L8.13873 9.20441L6.00001 5.50004L3.86172 9.20367L3.85694 9.21176C3.62524 9.59622 3.5 10.0467 3.5 10.5Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

FieldColorSmallIcon.tags = ['color', 'drop', 'paint', 'water', 'liquid'];

FieldColorSmallIcon.category = 'Color & Background';

FieldColorSmallIcon.iconSize = 16;
